<template>
  <SelectLayout>
    <section class="sgm">
      <div class="municipio-selector">
        <h1>Gestão Municipal</h1>
        <label for="select-municipio">Selecione o Município:</label>
      </div>
      <div class="field">
        <SearchableSelect
          :value="selectedUrl"
          :options="clienteOptions"
          placeholder="Selecione"
          search-placeholder="Buscar Município..."
          @input="onSelect"
        />
      </div>
    </section>
  </SelectLayout>
</template>

<script>
import SelectLayout from '@/components/layout/SelectLayout.vue'
import SearchableSelect from '@/components/ui/SearchableSelect.vue'
import { listClientes } from '@/services/socialApi.js'

export default {
  name: "Sgm",
  components: { SelectLayout, SearchableSelect },
  data() {
    return {
      selectedUrl: '',
      sgmClientes: []
    }
  },
  computed: {
    clienteOptions() {
      return this.sgmClientes.map((cliente, i) => ({
        value: cliente.url || String(i),
        label: `${cliente.cidade}, ${cliente.uf}`
      }))
    }
  },
  methods: {
    onSelect(url) {
      this.selectedUrl = url
      if (!url) return

      let destino
      try {
        destino = new URL(url.includes('://') ? url : `https://${url}/`)
      } catch (e) {
        return
      }

      if (destino.protocol !== 'http:' && destino.protocol !== 'https:') return

      window.location.href = destino.href
    }
  },
  mounted() {
    listClientes('sgm').then(response => {
      this.sgmClientes = response.data
    }).catch(() => {
      // lista fica vazia em caso de falha na API
    })
  }
}
</script>

<style scoped>
.sgm {
  width: 100%;
  max-width: 32rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 16px;
}

.sgm h1 {
  font-size: 24px;
  font-weight: bold;
  text-align: center;
}

.sgm label {
  font-size: 14px;
  text-align: center;
  color: #ccc;
  display: flex;
  justify-content: center;
}

.field {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.field-label {
  font-size: 12px;
  color: #ccc;
}

@media only screen and (max-width: 480px) {
  .sgm {
    gap: 12px;
  }

  .sgm h1 {
    font-size: 20px;
  }

  .sgm label {
    font-size: 13px;
  }
}
</style>
